'use strict';

import * as commonConstants from '../constants/constantStrings';

/**
 * Helper class for lookup operations (finding values by keys in arrays/objects)
 */
export class LookupHelpers {
  /**
   * Gets the full side name by code (L, R, B)
   * @param {string} code - The side code (L, R, B)
   * @returns {string} The full side name (Left, Right, Both) or the code if not found
   */
  static getFullSideByCode(code) {
    if (!code) {
      return code;
    }
    const side = commonConstants.FILMS_COMPARED_SIDE_OPTIONS.find(side => side.Key === code);
    return side && side.Value || code;
  }

  /**
   * Gets a value from an array of objects by matching a key property
   * @param {string} key - The key to find
   * @param {Array} items - Array of objects with Key and Value properties
   * @param {Object} options - Optional configuration
   * @param {string} options.keyProperty - Property name to use for key matching (default: 'Key')
   * @param {string} options.valueProperty - Property name to use for value extraction (default: 'Value')
   * @param {string} options.fallbackProperty - Fallback property name if valueProperty not found (default: 'Name')
   * @returns {string} The matched value or the key if not found
   */
  static getValueByKey(key, items, options) {
    if (!key) {
      return key;
    }

    if (!items || !Array.isArray(items) || items.length === 0) {
      return key;
    }

    const opts = options || {};
    const keyProperty = opts.keyProperty || 'Key';
    const valueProperty = opts.valueProperty || 'Value';
    const fallbackProperty = opts.fallbackProperty || 'Name';

    const item = items.find(item => {
      const itemKey = item[keyProperty] || item[valueProperty];
      return itemKey === key;
    });

    if (item) {
      return item[valueProperty] || item[fallbackProperty] || key;
    }

    return key;
  }

  /**
   * Gets the location name by location key from a locations array
   * @param {string} locationKey - The location key to find
   * @param {Array} locations - Array of location objects with Key and Value properties
   * @returns {string} The location Value/Name or the locationKey if not found
   */
  static getLocationName(locationKey, locations) {
    return LookupHelpers.getValueByKey(locationKey, locations, {
      keyProperty: 'Key',
      valueProperty: 'Value',
      fallbackProperty: 'Name'
    });
  }
}




// WEBPACK FOOTER //
// ./src/scripts/helpers/lookupHelpers.js